
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    DialogIndex: Number,
    DialogData: { default: () => { return {} }, type: Object as PropType<DialogData> }
  },
  data () {
    return {
      WarningType: [] as Array<WarningType>,
      Employees: [] as Array<Employee>,
      OriginalData: {} as any,
      Saving: false,
      Loading: [],
      ErrorsVisibilty: false,
      DialogMapper: [
        { Path: 'Reason', Res: 'D_Warning_Reason' },
        { Path: ['Employee', 'Name'], Res: 'D_Warning_Employee', ValuePath: 'ID', SavingPath: 'EmployeeID' },
        { Path: ['Type', 'Name'], Res: 'D_Warning_Type', ValuePath: 'ID', SavingPath: 'WarningTypeID' },
        { Path: 'CompanyID', Value: this.$store.state.CompanyManagment.CurrentCompany?.ID }
      ] as Array<DialogMapperObject>
    }
  },
  methods: {
    ReadWarningType () {
      this.Get('HR_WarningType').then(response => {
        this.WarningType = response
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading Warning Type'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    ReadEmployees () {
      this.Get('HR_Employees').then(response => {
        this.Employees = response
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading Employees'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    SaveData () {
      this.SaveDialogData({
        DialogMapper: this.DialogMapper,
        Parentthis: this,
        PostAPI: 'HR_Warnings',
        OriginalData: this.OriginalData,
        PatchAPI: 'HR_Warnings',
        Editing: this.DialogData.Editing,
        PatchQuery: '/' + this.DialogData?.Data?.ID
      })
    },
    DataSaved () {
      this.Saving = false
      this.$router.go(-1)
    }
  },
  mounted () {
    this.ReadWarningType()
    this.ReadEmployees()
    const Dialog = document.getElementById('CookiesDialog_' + this.DialogIndex)
    if (Dialog) {
      window.scrollTo(0, Dialog.offsetTop - 60)
    }
    if (this.DialogData.Editing) {
      this.OriginalData = this.CookiesDialogInitiator(this.DialogMapper, this.DialogData.Data)
      this.Console(this.OriginalData)
    }
  },
  watch: {
    CurrentDialogs: function (newVal, oldVal) { // watch it
      if (newVal < oldVal) {
        this.ReadWarningType()
        this.ReadEmployees()
      }
    }
  }
})
